module.exports = __webpack_public_path__ + "static/media/eficacia.8b8982ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/eficacia.jpg
// module id = 85
// module chunks = 0